import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Row, Col, Paper, Button, ColorBatch } from 'components';
import { geSignetDocumentForCredit } from 'services';
import { DOCUMENT_STATUS, dateTimeFormat, documentStatusName, documentStatusColorMap } from 'enums';
import { showApiError } from 'utils';
import { list } from 'styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
var signed = DOCUMENT_STATUS.signed;

var BorrowerContractsTab = function BorrowerContractsTab(_ref) {
  var _borrower$contracts;

  var borrower = _ref.borrower;

  var handleViewDocument = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(creditId, type) {
      var _yield$geSignetDocume, _yield$geSignetDocume2, res, err, url;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return geSignetDocumentForCredit(creditId, {
                type: type
              });

            case 2:
              _yield$geSignetDocume = _context.sent;
              _yield$geSignetDocume2 = _slicedToArray(_yield$geSignetDocume, 2);
              res = _yield$geSignetDocume2[0];
              err = _yield$geSignetDocume2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              url = URL.createObjectURL(new File([res], 'filename.json', {
                type: 'application/pdf'
              }));
              window.open(url, '_blank');

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleViewDocument(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  return ___EmotionJSX(Row, {
    justify: "space-between",
    align: "center",
    backgroundColor: "white"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(Paper, {
    header: function header(_ref3) {
      var css = _ref3.css;
      return ___EmotionJSX("div", {
        css: css
      }, ___EmotionJSX("h5", null, "\u0414\u043E\u0433\u043E\u0432\u043E\u0440\u0438"));
    },
    margin: "0 0 2em 0"
  }, ___EmotionJSX("div", {
    css: list
  }, ___EmotionJSX("table", {
    className: "list-table"
  }, ___EmotionJSX("thead", null, ___EmotionJSX("tr", null, ___EmotionJSX("th", null, "\u0418\u0414"), ___EmotionJSX("th", null, "\u041A\u0440\u0435\u0434\u0438\u0442 \u0418\u0414"), ___EmotionJSX("th", null, "\u0421\u0442\u0430\u0442\u0443\u0441"), ___EmotionJSX("th", null, "\u0422\u0438\u043F"), ___EmotionJSX("th", null, "\u041E\u0431\u043D\u043E\u0432\u0435\u043D \u043D\u0430"), ___EmotionJSX("th", null, "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0435"))), ___EmotionJSX("tbody", null, borrower === null || borrower === void 0 ? void 0 : (_borrower$contracts = borrower.contracts) === null || _borrower$contracts === void 0 ? void 0 : _borrower$contracts.map(function (el) {
    var _el$type;

    return ___EmotionJSX("tr", {
      key: el === null || el === void 0 ? void 0 : el.id
    }, ___EmotionJSX("td", null, el === null || el === void 0 ? void 0 : el.id), ___EmotionJSX("td", null, el === null || el === void 0 ? void 0 : el.credit_id), ___EmotionJSX("td", null, ___EmotionJSX(ColorBatch, {
      type: documentStatusColorMap[el === null || el === void 0 ? void 0 : el.status]
    }, documentStatusName[el === null || el === void 0 ? void 0 : el.status])), ___EmotionJSX("td", null, el === null || el === void 0 ? void 0 : (_el$type = el.type) === null || _el$type === void 0 ? void 0 : _el$type.replace(/_(\w)/g, function (_, p) {
      return " ".concat(p);
    })), ___EmotionJSX("td", null, moment(el === null || el === void 0 ? void 0 : el.updated_at).isValid() ? moment(el === null || el === void 0 ? void 0 : el.updated_at).format(dateTimeFormat) : 'N/A'), ___EmotionJSX("td", null, ' ', ___EmotionJSX(Button, {
      small: true,
      disabled: (el === null || el === void 0 ? void 0 : el.status) !== signed,
      fullWidth: true,
      onClick: function onClick() {
        return handleViewDocument(el === null || el === void 0 ? void 0 : el.credit_id, el === null || el === void 0 ? void 0 : el.type);
      }
    }, "\u0412\u0438\u0436")));
  })))))));
};

BorrowerContractsTab.propTypes = {
  borrower: PropTypes.object
};
export default BorrowerContractsTab;